import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import ProviderPriceListEditRoutes from './routes'

const ProviderPriceListEdit = () => {
  const { providerPriceListId } = useNumericParams()

  useReduxAction(
    'providerPriceLists',
    'loadProviderPriceList',
    {
      entityId: providerPriceListId,
      ...defaultRequestOptions.providerPriceList,
    },
    [providerPriceListId],
    {
      dispatchAction: (action, requestOptions) => action(providerPriceListId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }) => providerPriceListId && !loading,
    },
  )

  return (
    <ProviderPriceListEditRoutes providerPriceListId={providerPriceListId} />
  )
}

export default ProviderPriceListEdit
